import script from "./PortalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalView.vue?vue&type=script&setup=true&lang=ts"

import "./PortalView.vue?vue&type=style&index=0&id=001a1003&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001a1003"]])

export default __exports__